import React from "react";
import { Modal, Table } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useTable } from "react-table";
import { useTranslation } from "react-i18next";
import { ReactComponent as PollTitleIcon } from "../../images/links/questionbank_active_icon.svg";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";

import {
    BUTTON,
    DEFAULT_ROWS_PER_PAGE,
    QUESTION_TYPES,
    TEXTBOX,
} from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import styles from "./QuestionProfiles.module.css";
import {questionCodeToSVG} from "../../utils/questionUtils";

export default function ViewPollModal({setModalShow, show, pollData, dataReady}) {
    const { t } = useTranslation();
    const {pollTitle, questions=[]} = pollData;
    const handleClose = () =>{

        setModalShow(false);
    };





    const QuestionsTable = ({data=[]}) => {
        const columns = [
            { Header: t("poll.viewPollModalQuestionTitleHeader"), accessor: 'queTitle', textAlign: "left", width: 200 },
            // { Header: VIEW_POLL_MODAL_QUE_TYPE_HEADER, accessor: 'questionType', textAlign: "center", width: 100 },
        ];


        const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            prepareRow,
            rows,
        } = useTable({columns, data});


        return (
            <div className={styles.tableContainer} style={{border: "0.25px solid #646464", borderRadius: "5px", marginTop: "20px"}}>
                <Table hover {...getTableProps({style: {minHeight: rows.length ===0 ? "100%" : "", marginBottom: "0px"}})}>
                    <thead>
                        {headerGroups.map((headerGroup, index) => (
                            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th tabIndex={0} {...column.getHeaderProps({
                                        style: {
                                            width: column.width,
                                            minWidth: column.minWidth,
                                            textAlign: column.textAlign
                                        }
                                    })}>
                                      <PollTitleIcon style={{marginLeft: 3, width: "24px", height: "24px"}}/>  {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody className={styles.tablebody} {...getTableBodyProps({style: {overflowY: "auto", height: "100%", marginBottom: "0px"}})}>
                        {rows.map((row, index) => {
                                prepareRow(row)
                                // console.log(row)
                                return (
                                    <tr key={index} {...row.getRowProps()} >
                                        { row.cells.map((cell, index) => {

                                                return (
                                                    <td
                                                        key={index}
                                                        tabIndex={0}
                                                        aria-label={t("poll.viewPollModalQuestionTitleHeader") + " header " + cell.value}
                                                        role={TEXTBOX}
                                                        {...cell.getCellProps({style: {wordBreak: 'break-word', fontSize: "16px",  color: "#000000", textAlign: "left"}} )}
                                                    >
                                                        <span style={{display: "flex", alignItems: "center"}}>
                                                            {questionCodeToSVG(cell.row.original.questionType, false)}
                                                            <span style={{width: 10}}/>
                                                            <span
                                                                title={cell.value}
                                                                style={{flex: 1, overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis"}}
                                                            >
                                                                {cell.value}
                                                            </span>
                                                        </span>
                                                    </td>
                                                );

                                        })}
                                    </tr>
                                )
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
    
    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"qp-modal"}
        >

            <ModalClose tabIndex={0} role={BUTTON} aria-label={t("questionBank.closeModalAria")} onClick={handleClose} className="modal-close" style={{width: "24px", height: "24px"}}/>
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title tabIndex={0} role={TEXTBOX} aria-label={t("questionBank.modalTitle")} className="modal-title" id="contained-modal-title-vcenter">
                    {t("poll.viewPollModalTitle")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>

                    {dataReady &&
                        <>
                            <div
                                tabIndex={0}
                                role={TEXTBOX}
                                style={{
                                    width: "100%",
                                    textAlign: "left",
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                    color: "#000000",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis"
                                }}
                                title={pollTitle}
                            >
                                {t("table.pollTitleHeader")}:  <span style={{fontWeight: 400}}>{pollTitle}</span>
                            </div>
                            <QuestionsTable data={questions}/>
                        </>
                    }
                    {!dataReady &&
                        <div className={styles.skeletonTableContainer}>
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                <div className={styles.skeletonHeaderContainer2}>
                                    <div className={styles.skeletonHeaderCell}>{t("poll.viewPollModalQuestionTitleHeader")}</div>
                                </div>
                                <div className={styles.skeletonBodyContainer}>
                                    {Array.apply(null, Array(DEFAULT_ROWS_PER_PAGE)).map((_, idx) => {
                                        return (<div className={styles.skeletonBodyRow2} key={idx}>
                                            <Skeleton height={20}  borderRadius={10} inline={true}
                                                      width={`${6 + Math.random() * 3}vw`}
                                                      className={styles.skeletonBodyCell}
                                                      containerClassName={styles.skeletonBodyCellWrapper}/>
                                        </div>)
                                    })}
                                </div>
                            </SkeletonTheme>
                        </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton aria-label={t("questionBank.closeModalAria")} onClick={handleClose} type={"secondary"}>{t("common.close")}</YuJaButton>
            </Modal.Footer>

        </Modal>
    );
}